import React from "react"

import "../i18n/i18n"
import axios from "axios"
import classNames from "classnames/bind"
import styles from "../styles/Home.module.scss"
import CountUp from "react-countup"
import { withTranslation, Trans } from "react-i18next"
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"

import langMapping from "../constants/lang"

class Home extends React.Component {
  state = {
    curCount: 12145938,
  }

  // componentDidMount() {
  //   axios.get("https://s3.ap-northeast-2.amazonaws.com/spti.snackpot.kr/count/count.json", {}).then((result) => {
  //     this.setState({ curCount: result.data.count })
  //   })
  // }

  render() {
    const { curCount } = this.state
    const { t, lang } = this.props

    return (
      <>
        <Link to="/languageSelection">
          <div className={cn("language-selector")}>
            <img src="./images/earth.svg" alt="language" />
            <span>{langMapping[lang]}</span>
          </div>
        </Link>

        <h1 className={cn("main-title")}>
          <Trans i18nKey="home.mainTitle">
            내 성격에 딱!
            <br />
            어울리는 스낵은?
          </Trans>
        </h1>

        <h3 className={cn("sub-title")}>{t("home.subTitle")}</h3>

        <Link to="/question">
          <div className={cn("start-btn")}>
            <span className={cn("btn-text")}>{t("home.startButton")}</span>
            <CountUp start={0} end={curCount} duration={1.8} separator="," delay={0} decimals={0} decimal=",">
              {({ countUpRef }) => (
                <div className={cn("count-num")}>
                  {
                    <Trans i18nKey="home.userCount">
                      현재 총 <span className={cn("number")} ref={countUpRef}></span>명이 참여했어요.
                    </Trans>
                  }
                </div>
              )}
            </CountUp>
          </div>
        </Link>

        <img src="./images/logo_full.svg" alt="snackpot" className={cn("logo-img")} />
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  lang: state.general.lang,
})

const cn = classNames.bind(styles)

export default withRouter(connect(mapStateToProps)(withTranslation()(Home)))
